import { render, staticRenderFns } from "./dy-to-wx-v2.vue?vue&type=template&id=b31762ac&scoped=true&"
import script from "./dy-to-wx-v2.vue?vue&type=script&lang=js&"
export * from "./dy-to-wx-v2.vue?vue&type=script&lang=js&"
import style0 from "./dy-to-wx-v2.vue?vue&type=style&index=0&id=b31762ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31762ac",
  null
  
)

export default component.exports